{
  "password_length": "Password length must be between 8 and 50 characters",
  "password_strength": "Password must contain uppercase, lowercase letters and numbers"
}
